<template>
  <div class = 'head-tab-wrap'>
        <!-- <div class = 'head-tab-content' id = 'tabScroll'>
            <div @click = 'goTab(item)' class = 'head-tab-item'  v-for = '(item,index) in tabs' :key = "item.hash">
                <span :class = '{"theme-bg-primary-color":item.actived}' class = 'dian'></span>
                <span>{{item.title}}</span>
                <Icon v-show = 'tabs.length>1' @click.stop = 'deleTab(item,index)' class = "close-icon" type="md-close" />
                <span :id = "`mao${index}`" class = 'mao'></span>
            </div>
        </div> -->
        <Tabs  :closable = "tabs.length>1" :animated = "false" type="card" @on-click = "goTab1" @on-tab-remove = "deleTab1" :value = "activedTab">
            <TabPane  v-for = '(item,index) in tabs' :key = "item.hash" :label="item.title" :name="'tab'+index"></TabPane>
        </Tabs>
  </div>
</template>

<script>
export default {
    data(){
        return {
            activedTab: 'tab0'
        }
    },
    computed: {
        tabs(){
            return this.$store.state.main.menus.tabs
        },
    },
    created(){
        this.$store.commit('main/menus/setHeadTabVm',this)
    },
    watch: {
        $route: {
            handler(route) {
                if(route.meta&&route.meta.layout&&route.meta.layout != 'layoutDefault'){
                    return
                }
                let title = route.meta?route.meta.title:''
                if(route.query&&route.query.tab_title){
                    title = route.query.tab_title
                }
                let tabId = route.meta?route.meta.tabId:''
                //页签id以query中传入的权限最大，用来满足一个路由匹配多个页签的场景，防止找不到
                if(route.query&&route.query.tab_id){
                    tabId = route.query.tab_id
                }
                let queryStr = ''
                if(route.query){
                    for(let i in route.query){
                        queryStr+=`&${i}=${route.query[i]}`
                    }
                }
                if(route.name === "CustomObjectHandle"){
                    title = route.query.objectName
                }
                this.$eventBus.emit('TAB_ROUTE_CHANGE',route)
                this.$store.commit('main/menus/addTab',{
                    vm: this,
                    route: {
                        ...route,
                        title,
                        hash: location.hash,
                        tabId,
                        queryStr,
                        actived: true
                    }
                })
                this.setActived()
            },
            immediate: true
        }
    },
    methods: {
        //旧版
        goTab(route){
            // window.location.hash = route.hash
            this.$router.push({
                path: route.path,
                params: route.params,
                query: route.query
            })
        },
        deleTab(route,index){
            console.log('deleTab')
            let tabs = this.tabs
            if(tabs[index].actived){
                let activedIndex = index == 0?(index+1):(index-1)
                this.goTab(tabs[activedIndex])
            }
            this.$store.commit('main/menus/deleTab',index)
        },
        //ivie tab版本
        goTab1(name){
            this.activedTab = name
            let route = this.getRouteByIndex(name.split('tab')[1])
            // window.location.hash = route.hash
            this.$router.push({
                path: route.path,
                params: route.params,
                query: route.query
            })
        },
        deleTab1(name){
            console.log('deleTab')
            let index = Number(name.split('tab')[1])
            let tabs = this.tabs
            if(tabs[index].actived){
                let activedIndex = index == 0?(index+1):(index-1)
                this.goTab(tabs[activedIndex])
            }else{
                let activeIndex = Number(this.activedTab.split('tab')[1])
                if(index<activeIndex){
                    activeIndex--
                }
                this.activedTab = 'tab'+activeIndex
            }
            this.$store.commit('main/menus/deleTab',index)
        },
        //删除当前页签
        deleNowTab1(){
            this.deleTab1(this.activedTab)
        },
        getRouteByIndex(index){
            let tabs = this.$store.state.main.menus.tabs
            for(let i = 0;i< tabs.length;i++){
                if(i == index){
                    return tabs[i]
                }
            }
        },
        setActived(){
            let tabs = this.$store.state.main.menus.tabs
            for(let i in tabs){
                if(tabs[i].actived){
                    this.activedTab = 'tab'+i
                }
            }
        },
        //通过id删除tab
        deleTabById(id){
            let tabName = this.getTabNameById(id)
            if(tabName){
                this.deleTab1(tabName)
            }
        },
        //通过id跳转到某个tab
        switchTabById(id){
            console.log(id)
            let tabName = this.getTabNameById(id)
            tabName&&this.goTab1(tabName)
        },
        getTabNameById(id){
            let tabs = this.tabs
            for(let i in tabs){
                if(tabs[i].tabId&&(tabs[i].tabId == id)){
                    return 'tab'+i
                }
            }
        },
        //通过id获取对应的tabroute
        getTabRouteById(id){
            let tabs = this.tabs
            for(let i in tabs){
                if(tabs[i].tabId&&(tabs[i].tabId == id)){
                    return tabs[i]
                }
            }
        },
    }
}
</script>

<style lang = "less" scoped>
.head-tab-wrap{
    width:100%;
    min-height:35px;
    padding:5px 24px;
    padding-bottom:0;
    /* background:#fff; */
    border-top:1px solid #eee;
    overflow: hidden;
    .head-tab-content{
        white-space: nowrap;
        overflow-x: auto;
    }
    .head-tab-item{
        display: inline-block;
        height:30px;
        line-height:30px;
        padding:0 30px;
        padding-right:30px;
        font-size:14px;
        border:1px solid #ccc;
        margin-right:10px;
        cursor:pointer;
        background:#fff;
        position: relative;
        margin-bottom:5px;
        .mao{
            position:absolute;
            right:0;
            top:0;
            height:1px;
            width:1px;
        }
        .close-icon{
            position:absolute;
            right:2px;
            top:2px;
            color: #888;
            &:hover{
                color: #000;
                font-size: 16px;
            }
        }
        .dian{
            display:inline-block;
            width:10px;
            height:10px;
            background:#ccc;
            border-radius: 50%;
            margin-right:5px;
            position: absolute;
            left:10px;
            top:10px;
        }
        .tabactived{
            background:green;
        }
    }
    & /deep/ .ivu-tabs-bar{
        margin:0;
        border:0;
    }
    & /deep/ .ivu-tabs-tab{
        border: none!important;
        background:#fff!important;
    }
    & /deep/ .ivu-tabs-context-menu{
        height:0px;
    }
}
</style>